__turbopack_context__.v({
  "actions": "LoginPage-module-scss-module__TdgsRW__actions",
  "copyright": "LoginPage-module-scss-module__TdgsRW__copyright",
  "divider": "LoginPage-module-scss-module__TdgsRW__divider",
  "formError": "LoginPage-module-scss-module__TdgsRW__formError",
  "hidden": "LoginPage-module-scss-module__TdgsRW__hidden",
  "line-break": "LoginPage-module-scss-module__TdgsRW__line-break",
  "recaptchaContainer": "LoginPage-module-scss-module__TdgsRW__recaptchaContainer",
  "rememberMe": "LoginPage-module-scss-module__TdgsRW__rememberMe",
  "signUpLink": "LoginPage-module-scss-module__TdgsRW__signUpLink",
  "sso": "LoginPage-module-scss-module__TdgsRW__sso",
  "ssoButton": "LoginPage-module-scss-module__TdgsRW__ssoButton",
  "text-align_center": "LoginPage-module-scss-module__TdgsRW__text-align_center",
  "withRememberMe": "LoginPage-module-scss-module__TdgsRW__withRememberMe",
});
